import { useState } from 'react';
import { Playground } from 'docz';
import Input from "../../../../../src/components/Input/input";
import * as React from 'react';
export default {
  useState,
  Playground,
  Input,
  React
};